import { Moment } from "moment";
import { BookingPreConfirmationProduct } from "./booking-pre-confirmation-product";
import { Currency } from "./currency";
import Decimal from 'decimal.js';
import { BookingPreConfirmationTemplate } from "./booking-pre-confirmation-template";
import { LviBankInformation } from "./lvi-bank-information";

export class BookingPreConfirmation {


    constructor(
        public description: string,
        public comment: string,
        public productList: BookingPreConfirmationProduct[],
        public baseCurrency: Currency,
        public secondCurrency: Currency,
        public confirmationDate: Moment | null,
        public dueDate: Moment | null,
        public deposit: Decimal | null,
        public priceIncludes: string,
        public priceNotIncludes: string,
        public template: BookingPreConfirmationTemplate | null,
        public selectedBank: LviBankInformation,
        public middleComment: string,
        public hasDepositInReal: boolean,
        public id?: number
    ){}
}
